var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditCircled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.2202,
    r: 16,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.0736V23.7758C8 24.0247 8.19556 24.2202 8.44444 24.2202H11.1467C11.2622 24.2202 11.3778 24.1758 11.4578 24.0869L21.1644 14.3891L17.8311 11.0558L8.13333 20.7536C8.04444 20.8425 8 20.9491 8 21.0736ZM23.7422 11.8114C24.0889 11.4647 24.0889 10.9047 23.7422 10.558L21.6622 8.47802C21.3156 8.13135 20.7556 8.13135 20.4089 8.47802L18.7822 10.1047L22.1156 13.438L23.7422 11.8114Z",
    fill: "#646471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCircled);
export default __webpack_public_path__ + "static/media/edit-circled.d1f2d4acea7f38ce291392dff68dc11e.svg";
export { ForwardRef as ReactComponent };